import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  BS_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import {
  addClient,
  setAddClient,
} from '../../actions/advisor';
import s from './AddClientForm.css';

const blankClient = {
  firstName: '',
  lastName: '',
  email: '',
  tests: [LA_TEST,BS_TEST,RR_TEST],
};

class AddClientForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      client: blankClient,
    };
  }

  closeAddClientForm = () => {
    this.props.setAddClient(false);
  }

  // update the value to state for form text fields
  addClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
    } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // add a new client with current saved state values
  addClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    if(client.firstName !== '' && client.lastName !== '' && client.email !== '') {
      this.props.addClient(client);
      this.setState(Object.assign({}, this.state, {
        client: blankClient,
      }));
      this.props.setAddClient(false);
    }
  }

  render() {

    return (
      <div>
        <form>
          <div className={s.addClientForm + ' row'}>
            <div className="col-md-9">
              <div className={'row'}>
                <div className={s.copyText + ' col-md-12'}>
                Entering an existing client’s information or a sample client will allow you to set individual financial goals, risk tolerance and portfolios to analyze against WisdomTree Models. You or your client can complete a Behavioral Finance Assessment that will help you build a more personalized portfolio that truly fits their financial profile.   
                </div>
              </div>
              <div className={'form-group'}>
                  <label htmlFor="firstName" className={s.formLabel}>Client or Sample First Name</label>
                  <input
                    name="firstName"
                    value={this.state.client.firstName}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={`form-control ${s.formControl}`}
                    // placeholder="First Name"
                  />
              </div>
              <div className={'form-group'}>
                  <label htmlFor="lastName" className={s.formLabel}>Client or Sample Last Name</label>
                  <input
                    name="lastName"
                    value={this.state.client.lastName}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={`form-control ${s.formControl}`}
                    // placeholder="Last Name"
                  />
              </div>
              <div className={'form-group'}>
                  <label htmlFor="email" className={s.formLabel}>Client or Sample Email</label>
                  <input
                    name="email"
                    value={this.state.client.email}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={`form-control ${s.formControl}`}
                    // placeholder="Email"
                  />
              </div>
              <div className={'row'} style={{marginTop:'30px'}}>
                <div className='col-md-12'>
                  <div
                    onClick={this.addClient}
                    className={s.addClientButton}
                  >ADD</div>
                  <div
                    onClick={this.closeAddClientForm}
                    className={s.cancelClientButton}
                  >CANCEL</div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  addClient,
  setAddClient,
})(AddClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/AddClientForm.js